import { createRouter, createWebHistory } from 'vue-router'

import AccountList from '../views/AccountList.vue'
import Login from '../views/Login.vue'
import CatalogList from '../views/CatalogList.vue'
import SendMail from '../views/SendMail.vue'
import RegistNotice from '../views/RegistNotice.vue'
import AuthorityError from '../views/AuthorityError.vue'
import TermTypeError from '../views/TermTypeError.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/accountList',
    name: 'accountList',
    component: AccountList
  },

  {
    path: '/catalogList',
    name: 'catalogList',
    component: CatalogList
  },
  {
    path: '/sendMail',
    name: 'sendMail',
    component: SendMail
  },
  {
    path: '/registNotice',
    name: 'registNotice',
    component: RegistNotice
  },
  {
    path: '/authorityError',
    name: 'authorityError',
    component: AuthorityError
  },
  {
    path: '/termTypeError',
    name: 'termTypeError',
    component: TermTypeError
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});





export default router



